export default function setCookie(name, value, expDays) {
  let date = new Date();
  date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
  const expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + "; " + expires + "; path=/";
}

export function setCookieUnixTimestamp(name, value, unixTimestamp) {
  const ts = Number(unixTimestamp);
  const isMilliseconds = ts > 1000000000000;
  const date = new Date(isMilliseconds ? ts : ts * 1000);

  const expires = "expires=" + date.toUTCString();
  const encodedValue = encodeURIComponent(String(value));

  const domain = window.location && window.location.hostname
    ? "; domain=" + window.location.hostname
    : "";

  document.cookie =
    name +
    "=" +
    encodedValue +
    "; " +
    expires +
    "; path=/" +
    domain +
    "; Secure;";
}
